import { formatUnits } from "viem";
import { api } from "./api";
import { fileUrl } from "../components/TokenPageCustomize";

export const fmtAmt = (raw, decimals = 18) => {
  if (raw == null || raw === "") return "—";
  const n = Number(formatUnits(BigInt(raw), decimals ?? 18));
  return n.toLocaleString(undefined, { maximumFractionDigits: n < 1 ? 6 : 2 });
};

export const fmtLeft = (secs) => {
  if (secs <= 0) return "0s";
  const d = Math.floor(secs / 86400), h = Math.floor((secs % 86400) / 3600), m = Math.floor((secs % 3600) / 60), s = Math.floor(secs % 60);
  return d ? `${d}d ${h}h ${m}m` : h ? `${h}h ${m}m ${s}s` : `${m}m ${s}s`;
};

export const PHASE = {
  draft: ["Draft · deploy the pot", "text-slate-300"], awaiting_funding: ["Waiting for reward deposit", "text-warning"],
  upcoming: ["Upcoming", "text-sky-300"], live: ["Live", "text-lime"], ended: ["Ended · payout pending", "text-warning"],
  paid: ["Rewards paid", "text-lime"], unfunded: ["Expired — never funded", "text-slate-500"], cancelled: ["Cancelled", "text-slate-500"],
};

export const compLogo = (c) => fileUrl(c?.token_info?.logo);

export const confirmTrade = async (hash) => {
  for (let i = 0; i < 5; i++) {
    try { await api.post("/swap/confirm", { tx_hash: hash }); return; }
    catch (e) { if (e?.response?.status !== 409) return; await new Promise((r) => setTimeout(r, 3000)); }
  }
};
